<div class="choices-container">
  <ng-container *ngFor="let choice of choices">
    <mat-card class="choice-card" (click)="selectComponent(choice)">
      <mat-card-content>
        <h3 class="title">{{ choice.title | translate }}</h3>
        <p class="description">
          {{ choice.description | translate }}
        </p>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
